import React, { useState } from 'react';
import { Box, Paper, Grid, Tooltip } from '@mui/material';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import BookIcon from '@mui/icons-material/Book';
import ArticleIcon from '@mui/icons-material/Article';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import HomeCenAbout from './HomeCenterContents/HomeCenAbout';
import HomeCenWork from './HomeCenterContents/HomeCenWork';
import HomeCenBlogs from './HomeCenterContents/HomeCenBlogs';
import HomeCenResume from './HomeCenterContents/HomeCenResume';
import HomeCenContact from './HomeCenterContents/HomeCenContact';

const navItems = [
  { title: "About", icon: <PersonOutlineIcon />, component: <HomeCenAbout /> },
  { title: "Works", icon: <WorkOutlineIcon />, component: <HomeCenWork /> },
  { title: "Blogs", icon: <BookIcon />, component: <HomeCenBlogs /> },
  { title: "Resume", icon: <ArticleIcon />, component: <HomeCenResume /> },
  { title: "Contact", icon: <PermContactCalendarIcon />, component: <HomeCenContact /> }
];

function HomeCenter() {
  const [HomeCenView, setHomeCenView] = useState(0);

  const NavIconBox = ({ index, title, icon }) => (
    <Tooltip title={title}>
      <Box
        sx={{
          width: '40px',
          height: '40px',
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: '6px',
          display: 'grid',
          cursor: 'pointer',
          background: HomeCenView === index ? "#FF6969" : "#EEEEEE",
          color: HomeCenView === index ? "#fff" : "",
          '&:hover': {
            background: '#FF6969',
            color: '#fff',
          }
        }}
        onClick={() => setHomeCenView(index)}
        aria-label={title}
      >
        {icon}
      </Box>
    </Tooltip>
  );

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        '& > :not(style)': {
          m: 1,
          width: 870,
          minHeight: 630,
          borderRadius: 4,
        },
      }}
    >
      <Paper elevation={3}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box sx={{ display: 'flex', gap: 2, width: '100%', justifyContent: 'end', pr: 3, py: 3 }}>
              {navItems.map((item, index) => (
                <NavIconBox key={index} index={index} title={item.title} icon={item.icon} />
              ))}
            </Box>
          </Grid>
          <Grid item xs={12}>
            {navItems[HomeCenView].component}
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
}

export default HomeCenter;
